var TEMPLATE_CATEGORIES = 'TEMPLATE_CATEGORIES';
var TEMPLATE_STATUSES = 'TEMPLATE_STATUSES';
export { TEMPLATE_CATEGORIES, TEMPLATE_STATUSES };